<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px">协议信息</span>
      <button type="success" plain @click="exportResult" class="exportClass">导出</button>
      <!-- <download-excel :data="json_data" :fields="json_fields" :name="exName" class="exportClass">
        导出
      </download-excel> -->
      <!-- <el-upload
        class="upload-demo" style="float: right;margin-top: -5px;"
        action=""
        :on-change="handleChange"
        :show-file-list="false"
        :auto-upload="false">
        <el-button size="small" type="success" plain>导入</el-button>
      </el-upload> -->

        <el-upload
          class="upload-demo" style="float: right;margin-top: -5px;"
          action="https://jsonplaceholder.typicode.com/posts/" accept=".json" :on-success="onSuccess"
          :show-file-list="false">
          <el-button size="small" type="success" plain>导入</el-button>
        </el-upload>

      <!-- <div>

        <input id="file" type="file" accept=".json"/>
        <button type="success" plain @click="importResult">导入txt</button>
      </div> -->

    </div>
    <div class style="margin-top: 30px;">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="协议名称" prop="name">
          <el-row>
            <el-col :span="12">
              <el-input v-model="form.name" placeholder="请输入告警通知组名称"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="协议内容" prop="content">
          <el-row style="margin-left: 20px">
            <el-col :span="8">
              <span>协议中文</span>
            </el-col>
            <el-col :span="8">
              <span>协议英文</span>
            </el-col>
            <el-col :span="8">
              <span>数据类型</span>
            </el-col>
          </el-row>
          <el-row v-for="(_item, index) in form.content" :key="index" style="margin-left: 20px">
            <el-col :span="8">
              <el-input v-model="_item.protocolCHS" placeholder="请输入协议中文" style="width: 80%" ></el-input>
            </el-col>
            <el-col :span="8">
              <el-input v-model="_item.protocolENG" placeholder="请输入协议英文" style="width: 80%" ></el-input>
            </el-col>
            <el-col :span="5">
              <el-select v-model="_item.dataType" placeholder="请选择数据类型">
                <el-option label="数值类型" :value="'数值类型'"></el-option>
                <el-option label="时间类型" :value="'时间类型'"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <i class="el-icon-remove-outline" style="font-size: 45px; color: red" v-if="form.content.length > 1" @click="deleteAgreeItem(index)"></i>
              <i class="el-icon-circle-plus-outline" style="font-size: 45px; color: rgba(0, 204, 0, 1)" v-if="index == form.content.length - 1" @click="addAgreeItem"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
export default {
  name: "reviseAgreement",
  components: {},
  data() {
    return {
      form: {
        name: "",
        content: [{ protocolCHS: "", protocolENG: "", dataType: "数值类型" }],
      },
      exName:'',//表名称
      json_data:[], // 表内容
      json_fields:{  //表头
        '序号':'type',
        '协议中文':'protocolCHS',
        '协议英文':'protocolENG',
        '数据类型':'dataType'
      },
      rules: {
        name: [{ required: true, message: "请输入协议名称", trigger: "blur" }],
        content: [{ required: true, message: "" }],
      },
      fileContent: '',
      file: '',
      data: ''
    };
  },
  computed: {},
  methods: {
    exportResult(){
      console.log(1111)
      // 将json转换成字符串
      const data = JSON.stringify(this.form.content)
      console.log(data,'2222')
      const blob = new Blob([data], {type: 'application/json'})
      FileSaver.saveAs(blob, '协议内容.json')
    },
    onSuccess(res,file,fileList){
      console.log(res,'res',file,'file',file.raw)
      if(file.raw){
        console.log(true)
        this.getData(file.raw)
      }else{
        console.log(false)
      }

    },
    getData(file){
      const reader = new FileReader()
      reader.readAsText(file)
      const _this = this
      let datadd = []
      reader.onload = function () {
        // this.result为读取到的json字符串，需转成json对象
        datadd = JSON.parse(this.result)
        // 检测是否导入成功
        console.log(datadd,'dddddddd')
        _this.form.content = datadd
      }
    },


    // importResult(){
    //   const file = document.getElementById('file').files[0]
    //   console.log(file,'file')
    //   const reader = new FileReader()
    //   reader.readAsText(file)
    //   const _this = this
    //   let datadd = []
    //   reader.onload = function () {
    //     // this.result为读取到的json字符串，需转成json对象
    //     datadd = JSON.parse(this.result)
    //     // 检测是否导入成功
    //     console.log(datadd,'dddddddd')
    //   }
    // },
    cancel() {
      this.form = {
        name: "",
        content: [{ protocolCHS: "", protocolENG: "", dataType: "数值类型" }],
      };
      this.$router.go(-1);
    },
    deleteAgreeItem(index) {
      this.form.content.splice(index, 1);
    },
    addAgreeItem() {
      let _item = { protocolCHS: "", protocolENG: "", dataType: "数值类型" };
      this.form.content.push(_item);
    },
    // save() {
    async save() {
      try {
        //必填校验
        await Promise.all([
          this.$refs.form.validate(),
        ]);
      } catch (error) {
        return;
      }
      for(var i=0;i<this.form.content.length;i++){
        if(!this.form.content[i].protocolCHS || !this.form.content[i].protocolENG){
          this.$notify({
            title: "失败",
            message: "请填写完整协议内容",
            type: "warning"
          });
          return
        }
      }
      let data = {
        name: this.form.name,
        content: this.form.content,
        id:this.form.id
      };
      console.log(data,'ddd')
      this.$store.dispatch("form/handle", {
        url: "/battery/dcProtocol/post",
        data: data,
        method: "post",
        callback: (resp) => {
          this.$router.go(-1);
        },
      });
    },
    // 自定义上传 导入数据
    // 注意：handleDelete 和 handelEdit 这两个方法其实是无关紧要的，只不过我的处理逻辑中有 修改 和 删除 这两个功能，不写的话，会报错
    handleDelete (item) {
      console.log('handleDelete', item)
    },
    handelEdit (item) {
      console.log('handleDelete', item)
    },
    // 核心部分代码(handleChange 和 importfile)
    handleChange (file, fileList) {
      this.fileContent = file.raw
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (this.fileContent) {
        if (fileType === 'xlsx' || fileType === 'xls') {
          this.importfile(this.fileContent)
        } else {
          this.$message({
            type: 'warning',
            message: '附件格式错误，请重新上传！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请上传附件！'
        })
      }
    },
    importfile (obj) {
      const reader = new FileReader()
      const _this = this
      reader.readAsArrayBuffer(obj)
      reader.onload = function () {
        const buffer = reader.result
        const bytes = new Uint8Array(buffer)
        const length = bytes.byteLength
        let binary = ''
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        const XLSX = require('xlsx')
        const wb = XLSX.read(binary, {
          type: 'binary'
        })
        const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
        this.data = [...outdata]
        console.log(this.data,'shuju')
        const arr = []
        _this.form.content = [{ protocolCHS: "", protocolENG: "", dataType: "数值类型" }]
        this.data.map(v => {
          const obj = {}
          obj.protocolCHS = v['协议中文']
          obj.protocolENG = v['协议英文']
          obj.dataType = v['数据类型']
          arr.push(obj)
        })
        console.log(arr,'2222')
        let newArr = _this.form.content.concat(arr)
        _this.form.content = newArr.slice(1)
      }
    },
  },
  mounted() {},
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    let detail = this.$route.query.data;
    console.log(detail,'ddddd')
    this.form = {
      name: detail.name,
      id:detail.id,
      content: JSON.parse(detail.content)
    };
    this.exName = this.form.name + '协议内容表'
    this.json_data = this.form.content
    for(let i in this.json_data){
      this.json_data[i].type=parseInt(i)+1
    }
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}

.exportClass{
  float:right;
  background: #f0f9eb;
  width: 50px;height: 30px;
  text-align: center;line-height: 30px;
  margin-top: -5px;margin-left: 10px;
  border: 1px solid #c2e7b0;color: #93c26d;
  border-radius: 3px;
  cursor: pointer;
}
.exportClass:hover{
  background: #67c23a;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/agreementManagement/reviseAgreement.vue